import AppLoader from "@/components/AppLoader";
import FirstConnectionPage from "@/presentation/firstConnection/FirstConnectionPage";
import { useServiceContext } from "@cs_teamwaydev/mailvista-sdk_react";
import { Outlet } from "react-router-dom";

const CheckServiceInitialization = () => {
    // AB#1721 — On lit `startupType` directement sur le contexte services (état interrogeable),
    // au lieu d'écouter un event de startup transitoire : ce gate étant monté APRÈS le consentement
    // (donc après l'émission de l'event), un abonnement raterait l'event. La valeur du contexte,
    // elle, est disponible dès le montage.
    const { isInitialized, startupType, sdk } = useServiceContext();

    if (!isInitialized) {
        // Un nouvel utilisateur SANS licence ne passe pas par l'analyse initiale
        // (sautée par le SDK) : afficher le loader générique plutôt qu'un flash de l'écran
        // d'onboarding. Fiable dès que startupType vaut 'new-user' : le seed des licences
        // fait partie de la Phase 0, qui précède ce changement d'état.
        const showFirstConnection =
            startupType === "new-user" &&
            (sdk?.licenseManager.hasValidLicense() ?? false);

        return showFirstConnection ? <FirstConnectionPage /> : <AppLoader />;
    }

    return <Outlet />;
};

export default CheckServiceInitialization;
